import { RobotoDashboardRevisionConflictException } from "./exceptions";

/**
 * Whether a failure is worth reporting to error monitoring.
 *
 * False for expected, user-resolvable outcomes that already have dedicated UI —
 * these are a normal part of the product's flow, not defects, and reporting them
 * buries real failures in noise.
 *
 * A dashboard revision conflict is the first such case: two people editing the
 * same dashboard is ordinary, the server rejecting the second save is the
 * feature working, and the user is handed a dialog to resolve it.
 */
export function shouldReportError(error: unknown): boolean {
  return !(error instanceof RobotoDashboardRevisionConflictException);
}
